<template>
    <vue-tags-input
        v-model="tag"
        :autocomplete-items="filteredItems"
        @tags-changed="newTags => model = newTags"
        :add-on-key="[13, 9]"
        :placeholder="placeholder"
        :separators="[',']"
        class="tag_input"
        :tags="tags"
        :autocomplete-min-length="3"
        @before-adding-tag="validTag"
    ></vue-tags-input>
</template>


<script>
    import Http from '../../utils/http'
    import { VueTagsInput, createTags } from '@johmun/vue-tags-input'
    import { isNil } from 'lodash'

    export default {
        components: {
            VueTagsInput
        },
        data () {
            return {
                tag: '',
                autocompleteItems: [],
                model: '',
                tags: [],
                validation: []
            }
        },
        mounted () {
            this.getItems()
            this.checkTags()
        },
        props: {
            url: {
                type: String,
                required: false,
                default: () => null
            },
            placeholder: {
                type: String,
                required: false,
                default: () => ' '
            },
            unfilteredTags: {
                required: true,
                default: () => []
            },
            options: {
                required: false,
                default: () => false
            },
            optionKey: {
                required: false,
                default: () => 'name'
            },
            type: {
                required: false,
                default: () => false
            }
        },
        watch: {
            model () {
                this.$emit('input', this.model)
            },
            'unfilteredTags' (val) {
                if (!isNil(val) && val.length === 0) {
                    this.model = this.unfilteredTags
                    window.jQuery(this.$el).find('.tag.valid').remove()
                }
            },
            url () {
                this.getItems()
            }
        },
        computed: {
            filteredItems () {
                if (this.options) {
                    let vm = this
                    let options = this.options.map(function (item) {
                        return {text: item[vm.optionKey]}
                    })
                    return options.filter(i => new RegExp(this.tag, 'i').test(i.text))
                }
                return this.autocompleteItems.filter(i => new RegExp(this.tag, 'i').test(i.text))
            }
        },
        methods: {
            getItems () {
                if (this.url) {
                    this.autocompleteItems = []
                    let vm = this
                    Http.get(this.url)
                        .then(response => {
                            Object.keys(response.data).forEach(function (key) {
                                vm.autocompleteItems.push({text: response.data[key].text})
                            })
                        })
                }
            },
            checkTags () {
                if (!Array.isArray(this.unfilteredTags) && !isNil(this.unfilteredTags)) {
                    let tagsArray = this.unfilteredTags.split(',')
                    this.model = createTags(tagsArray)
                    this.tags = this.model
                }
            },
            validTag (obj) {
                if (this.type === 'email') {
                    let regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/
                    if (!regex.test(obj.tag.text))
                        return false
                }
                obj.addTag()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/form/AutoCompleteTagInput.vue